module.exports = __webpack_public_path__ + "static/media/Gel.aacf7315.svg";